import { HttpMethod, Performer } from '../core'

export class StopFarming extends Performer<
  void,
  {
    status: 'success' | 'failed'
    balance?: bigint
  }
> {
  protected method = HttpMethod.POST
  protected url = '/stop-farming'
}
